
























































































































































import { computed, defineComponent, reactive, ref, PropType } from '@vue/composition-api';
import { TranslateResult } from 'vue-i18n';
import {
  formatDuration,
  bitrateFormatter,
  getFileNameAndExtension,
  uploadTableFormatVerifyMsg,
} from '@tt4b/ttam-utils';
import { i18n } from '@tt4b/ttam-i18n';
import { useMaterialNameValidate } from '@tt4b/ttam-hooks';
import { FileUploadStatus, MaterialType, VideoToUpload } from '@tt4b/ttam-enums';

import TtamALink from 'src/components/common/a-link/a-link.vue';
import TtamMaterialUploadSelectTableSuggestion from './select-table-suggestion.vue';
import TtamMaterialUploadSelectTableNameChange from './select-table-name-change.vue';

const name = 'ttam-material-upload-select-table';

export default defineComponent({
  name,

  components: {
    TtamALink,
    TtamMaterialUploadSelectTableSuggestion,
    TtamMaterialUploadSelectTableNameChange,
  },

  props: {
    files: { type: Array as PropType<VideoToUpload[]>, default: () => [] },
    fileType: { type: String as PropType<MaterialType>, default: MaterialType.Video },
    inventoryCheck: { type: Boolean, default: () => true },
  },

  setup(props, ctx) {
    const { formatSize } = uploadTableFormatVerifyMsg();
    const fileUploadStatus = computed(() => FileUploadStatus);

    const tableNode = ref();
    const selectedItems = ref([]);
    const nameChanging = ref(false);
    const nameChangeError = ref('');

    /** 选中事件 */
    function onSelectChange(val) {
      selectedItems.value = val;
      ctx.emit('select', selectedItems.value);
    }

    /** 判断传入的 app 是否通过校验 */
    function getIsAppValidatePass(status, shouldCut) {
      return Boolean(status || shouldCut);
    }

    /** 整合所有版位的校验信息 */
    function getAllSuggestion(file) {
      let allResult = [] as (string | TranslateResult)[];
      (file.placementValidateResult ?? []).forEach(inventory => {
        inventory.message.forEach(msg => {
          allResult.push(`${inventory.label}:${msg}`);
        });
      });
      return allResult;
    }

    /** 关闭修改 name 的 popover */
    function onCancelNameChange() {
      nameChanging.value = false;
      nameChangeError.value = '';
      document.body.click();
    }

    /** 获取不带扩展名的文件名称 */
    function getFileName(fullName: string) {
      return getFileNameAndExtension(fullName)?.excludeExtName ?? '';
    }

    /** 传入的文件是否 ready */
    function getIsFileReady(file) {
      return file.status === FileUploadStatus.VerifyPass && !file.nameValidate;
    }

    function getFileNameValidateMsg(file) {
      if (!file.nameValidate) {
        return '';
      }
      return (
        {
          [FileUploadStatus.NameDuplicate]: i18n.t('module_library_filename_duplicate'),
          [FileUploadStatus.NameIncludeEmoji]: i18n.t('module_library_filename_emoji_hint'),
          [FileUploadStatus.NameLengthInvalid]: i18n.t('module_library_filename_length_hint'),
        }[file.nameValidate] ?? ''
      );
    }

    /** 选中所有可选的视频 */
    function selectAll() {
      props.files.forEach(row => tableNode.value.toggleRowSelection(row, getIsFileReady(row)));
    }

    /** 确认修改 name */
    function onConfirmNameChange(targetName: string, material) {
      nameChanging.value = true;
      nameChangeError.value = '';
      const { extension } = getFileNameAndExtension(material.name);
      const otherNames = props.files.filter(file => file !== material).map(i => i.name);

      useMaterialNameValidate({
        otherNames,
        type: MaterialType.Video,
        targetName: `${targetName}${extension}`,
      })
        .then(res => {
          const { msg = '' } = res;
          if (msg) {
            nameChangeError.value = msg as string;
            return;
          }
          material.name = `${targetName}${extension}`;
          material.raw = new window.File([material.raw], material.name, {
            type: material.raw.type,
          });
          onCancelNameChange();
          if (material.nameValidate === FileUploadStatus.NameDuplicate) {
            material.nameValidate = '';
            material.disabled = false;
            selectAll();
          }
        })
        .finally(() => (nameChanging.value = false));
    }

    return {
      tableNode,
      nameChanging,
      nameChangeError,
      selectedItems,
      fileUploadStatus,

      formatSize,
      formatDuration,
      bitrateFormatter,

      getFileName,
      getIsFileReady,
      getAllSuggestion,
      getFileNameValidateMsg,
      getIsAppValidatePass,

      selectAll,
      onSelectChange,
      onCancelNameChange,
      onConfirmNameChange,
    };
  },
});
